/* eslint-disable function-paren-newline, comma-dangle */
import moment from 'moment';
import browser from '@openclassrooms/utils/browser';
import { initI18n } from '@openclassrooms/translations';
import { initImagesCdn } from '@openclassrooms/images-cdn';
import { setLocalisationConfigByCountry } from '@openclassrooms/localisation/services';

import { getConfiguration as getI18nConfiguration } from 'Modules/i18n';
import { errorTracker } from 'Modules/event';

import initService from './Inits/init';

const { App } = browser.window;

const legacyScripts = [
  App.script.SHOP,
  App.script.PAYMENT,
  App.script.TEAM,
  App.script.MENTORSHIP_STUDENT_DASHBOARD,
  App.script.ADMIN,
  App.script.USER_PROFILE,
  App.script.MCQ_EDIT,
  App.script.GIG_WORKERS,
  App.script.MCQ_VIEW, // Remove old RichContent to remove it from list.
  App.script.SECURITY,
  App.script.PATHS,
];

const scripts = {
  [App.script.WEBAPP]: () => import(/* webpackChunkName: "webapp" */ './webapp'),
  [App.script.MENTORSHIP_STUDENT_DASHBOARD]: () =>
    import(
      /* webpackChunkName: "mentorshipStudentDashboard" */ 'Modules/spaces/mentor/screens/init'
    ),
  [App.script.SHOP]: () => import(/* webpackChunkName: "shop" */ './shop'),
  [App.script.PAYMENT]: () => import(/* webpackChunkName: "payment" */ './payment'),
  [App.script.PROJECTS]: () => import(/* webpackChunkName: "projects" */ './projects'),
  [App.script.TEAM]: () => import(/* webpackChunkName: "team" */ 'Modules/Teams'),
  [App.script.ADMIN]: () => import(/* webpackChunkName: "admin" */ './admin'),
  [App.script.GIG_WORKERS]: () => import(/* webpackChunkName: "gigWorkers" */ 'Modules/gigWorkers'),
  [App.script.JOB_SURVEY]: () =>
    import(/* webpackChunkName: "jobSurvey" */ 'Modules/survey-job/index'),
  [App.script.MCQ_EDIT]: () => import(/* webpackChunkName: "mcqEdit" */ './Inits/McqEdit/index'),
  [App.script.MCQ_VIEW]: () => import(/* webpackChunkName: "mcqView" */ './Inits/McqView/mcq'),
  [App.script.PATHS]: () => import(/* webpackChunkName: "paths" */ 'Modules/learning-path'),
  [App.script.USER_PROFILE]: () => import(/* webpackChunkName: "userProfile" */ './userProfile'),
  [App.script.SECURITY]: () => import(/* webpackChunkName: "security" */ 'Modules/security'),
  [App.script.ERRORS]: () =>
    import(/* webpackChunkName: "errors" */ 'Modules/errors/screens/TwigExceptionRender'),
};

async function startAllModules() {
  await import(/* webpackChunkName: "commonOld" */ './common.old');

  App.modules.startAll();
}

const handleError = (error) => {
  errorTracker.captureError(error);
  // eslint-disable-next-line no-console
  console.error(error);
};

export default async (config) => {
  let script;
  const { country } = window.App.user;
  const isJqueryUiDependantPage = window.location.href.match(/\/projects\/.*/);
  const isScriptLegacy =
    legacyScripts.indexOf(App.scriptToLoad) !== -1 || !App.scriptToLoad || isJqueryUiDependantPage;

  App.preferences = { ...App.preferences, ...config };

  await Promise.all([initI18n(getI18nConfiguration(), { moment })]);

  initImagesCdn({ isEnabled: config.cdnImage });

  setLocalisationConfigByCountry(country, window.App.user.language);

  /*
    TL;DR: If the bundle is dependant of jquery-ui, common.old and vendorOld are loaded before
    bundle.

    jQuery-UI creates a global variable $.widget, so if we load the bundle before it will crash
    because it needs this variable.

    To recognize the error, it throws: "jquery ui is not available in this context"
   */
  try {
    if (isScriptLegacy) {
      await startAllModules();
    }

    const scriptLoader = scripts[App.scriptToLoad];

    if (scriptLoader) {
      ({ default: script } = await scriptLoader());
    }

    if (script) {
      initService.launch(script).catch(handleError);
    }

    if (!isScriptLegacy) {
      await startAllModules();
    }
  } catch (error) {
    handleError(error);
  }

  import(/* webpackChunkName: "lazy-common" */ 'Modules/lazy-common').catch(handleError);
};
